<div class="modal-body">
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
    <app-making-appointment-search [focusSearchElement]="focusSearchElement" (submittedSearch)="bsModalRef.hide()"></app-making-appointment-search>
</div>